<template>
    <div class="max-w-(--breakpoint-sm) flex flex-col gap-4">
        <page-header>Security</page-header>

        <update-password />

        <div v-if="user && !user.uses_two_factor_auth">
            <enable-two-factor-auth />
        </div>

        <div v-if="user && user.uses_two_factor_auth">
            <disable-two-factor-auth :user="user" />
        </div>
    </div>
</template>

<script setup>
import PageHeader from '~/components/general/PageHeader.vue';

import UpdatePassword from './UpdatePassword.vue';
import EnableTwoFactorAuth from './EnableTwoFactorAuth.vue';
import DisableTwoFactorAuth from './DisableTwoFactorAuth.vue';

defineProps({
    user: {
        type: Object,
        required: true,
    },
});
</script>
